<template>
    <span>{{ locationIndex }}
    <template v-if="!completed">
      <template v-if="isQuestion">
        <template v-if="pageType == 'Question' || pageType == 'IdealTextQuestion'">Q</template>
        <template v-if="pageType == 'question-feedback' || pageType == 'ideal-text-feedback'">A</template>
      </template>
    </template>
    / {{ pageCount }}</span>
</template>

<script>
    export default {
        name: 'ProgressRatio',
        props: ['locationIndex', 'completed', 'pageType', 'pageCount', 'isQuestion']
    }
</script>
